var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "107px",
    height: "85px",
    viewBox: "0 0 107 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5B9A\\u671F\\u30E1\\u30F3\\u30C6\\u30CA\\u30F3\\u30B9\\u4E2D",
    transform: "translate(-135.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(135.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(11.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#8DA7B5",
    strokeWidth: 2,
    fill: "#C7D9E8",
    x: 16,
    y: 0,
    width: 53,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-11",
    stroke: "#91AAB8",
    strokeWidth: 3,
    points: "0 24.1922759 0 3 16.4785071 3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-11",
    stroke: "#91AAB8",
    strokeWidth: 3,
    transform: "translate(76.239254, 13.596138) scale(-1, 1) translate(-76.239254, -13.596138) ",
    points: "68 24.1922759 68 3 84.4785071 3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#D8D8D8",
    x: 50.6694451,
    y: 7.5,
    width: 9,
    height: 9,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#8DA7B5",
    strokeWidth: 2,
    fill: "#C7D9E8",
    x: 1.16944507,
    y: 1,
    width: 104,
    height: 64,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 16.8981549,
    x2: 106,
    y2: 16.8981549,
    id: "Path-10",
    stroke: "#91AAB8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(42.169445, 38.000000)",
    fill: "#DA7575"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.5,
    y: 0,
    width: 9,
    height: 22,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(11.000000, 11.000000) rotate(90.000000) translate(-11.000000, -11.000000) ",
    x: 6.5,
    y: 0,
    width: 9,
    height: 22,
    rx: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.1694451,7.5 C56.859801,7.5 57.484801,7.77982203 57.937212,8.23223305 C58.389623,8.68464406 58.6694451,9.30964406 58.6694451,10 L58.6694451,10 L58.6694451,16 L48.1694451,16.5 L47.6694451,10 C47.6694451,9.30964406 47.9492671,8.68464406 48.4016781,8.23223305 C48.8540891,7.77982203 49.4790891,7.5 50.1694451,7.5 L50.1694451,7.5 Z",
    id: "Rectangle",
    stroke: "#979797",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1694451,6.5 C57.1359434,6.5 58.0109434,6.89175084 58.6443188,7.52512627 C59.2776942,8.15850169 59.6694451,9.03350169 59.6694451,10 L59.6694451,10 L59.6694451,21 L47.1694451,21.5 L46.6694451,10 C46.6694451,9.03350169 47.0611959,8.15850169 47.6945713,7.52512627 C48.3279468,6.89175084 49.2029468,6.5 50.1694451,6.5 L50.1694451,6.5 Z",
    id: "Rectangle",
    stroke: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1694451,17.5 L58.6694451,28 C58.6694451,28.6903559 58.389623,29.3153559 57.937212,29.767767 C57.484801,30.220178 56.859801,30.5 56.1694451,30.5 L56.1694451,30.5 L50.1694451,30.5 C49.4790891,30.5 48.8540891,30.220178 48.4016781,29.767767 C47.9492671,29.3153559 47.6694451,28.6903559 47.6694451,28 L47.6694451,28 L47.6694451,18 L58.1694451,17.5 Z",
    id: "Rectangle-Copy",
    stroke: "#979797",
    fill: "#D8D8D8"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.d332d800f50f2cae1b7528e41de6fef4.svg";
export { ForwardRef as ReactComponent };